module.exports = __webpack_public_path__ + "static/media/2012_Karneval_in_Baerbroich.1c41b15e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/gallery/TK_karneval/thumb/2012_Karneval_in_Baerbroich.jpg
// module id = 464
// module chunks = 0